// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { IAMUser, QueueAlertAction, AlertType } from '@app/core';
import { State } from '../../../state/index';
import { GroupDeleteModalComponent, RemoveResult } from '../../group-delete-modal/group-delete-modal.component';
import { GroupsService } from '../../../core/services/group.service';
import { RemoveUserFromGroupAction } from '@app/access-management/state/group-details/group-details.actions';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';

@Component({
  selector: 'app-group-details-users-tab',
  templateUrl: './group-details-users-tab.component.html',
  styleUrls: ['./group-details-users-tab.component.scss']
})
export class GroupDetailsUsersTabComponent implements OnInit, AfterViewInit {
  @ViewChild('actionTemplate') actionTemplate: any;
  @ViewChild('dataTableAjax') dataTableAjax!: DataTableAjaxComponent;
  columns: any = [];
  @Input() groupId!: string;

  constructor(
    private modalService: NgbModal,
    private store: Store<State>,
    private groupService: GroupsService) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.columns = [
      {
        name: 'Username',
        prop: 'username',
        flexGrow: 2
      },
      {
        name: 'Actions',
        prop: 'id',
        cellTemplate: this.actionTemplate,
        sortable: false,
        flexGrow: 1
      }
    ];
  }

  onRemoveRow(row: any) {
    const modalRef = this.modalService.open(GroupDeleteModalComponent, { centered: true, windowClass: 'no-border' });
    modalRef.componentInstance.rowId = this.groupId;
    modalRef.componentInstance.observable = this.groupService.deleteUserFromGroup(this.groupId, row.user_group_id);
    modalRef.result.then(result => {
      switch (result) {
        case RemoveResult.REMOVE_SUCCEEDED: {
          this.dataTableAjax.refreshTable();
          this.store.dispatch(
            new QueueAlertAction({ alertText: `User delete succeeded.`, alertType: AlertType.SUCCESS })
          );
          break;
        }
        case RemoveResult.REMOVE_FAILED: {
          this.store.dispatch(new QueueAlertAction({ alertText: `User delete failed.`, alertType: AlertType.ERROR }));
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  trackColumns(idx: number) {
    return idx;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/groups/group-details/group-details-users-tab/group-details-users-tab.component.ts